import React from 'react';
import Icon from '../../../components/AppIcon';

const ExportPanel = ({ onExport }) => {
  const exportOptions = [
    { format: 'pdf', label: 'PDF Report', icon: 'FileText' },
    { format: 'excel', label: 'Excel Spreadsheet', icon: 'Sheet' },
    { format: 'csv', label: 'CSV Data', icon: 'Database' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="font-semibold text-foreground mb-3">Export Options</h3>
      <div className="space-y-2">
        {exportOptions?.map((option) => (
          <button
            key={option?.format}
            onClick={() => onExport?.(option?.format)}
            className="w-full flex items-center gap-3 px-4 py-3 bg-muted hover:bg-muted/80 rounded-lg transition-colors text-left"
          >
            <Icon name={option?.icon} size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">{option?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExportPanel;